import styled from 'styled-components';

const BurgerMenuIconStyle = styled.div`
	--sizeBtnWidth: var(--sp3x);
	--sizeLineHeight: var(--sp0-5x);
	--distanceLine: var(--sp1x);
	--radiusLine: var(--sp100x);

	.all-btn {
		height: fit-content;
	}

	.menu-btn-1 {
		height: calc(var(--sizeLineHeight) * 3 + (var(--distanceLine) - var(--sizeLineHeight)) * 2);
		width: var(--sizeBtnWidth);
		cursor: pointer;
		display: flex;
		align-items: center;
		transition: var(--trTime) ease-in-out;
	}

	.menu-btn-1 span,
	.menu-btn-1 span::before,
	.menu-btn-1 span::after {
		background: var(--textPrimaryColor);
		border-radius: var(--radiusLine);
		content: '';
		position: absolute;
		width: var(--sizeBtnWidth);
		height: var(--sizeLineHeight);

		-webkit-transition: var(--trTime) ease-in-out;
		-moz-transition: var(--trTime) ease-in-out;
		-o-transition: var(--trTime) ease-in-out;
		transition: var(--trTime) ease-in-out;
	}

	.menu-btn-1 span::before {
		margin-top: calc(var(--distanceLine) * -1);
	}

	.menu-btn-1 span::after {
		margin-top: var(--distanceLine);
	}

	.menu-btn-1.active {
		transform: translateX(calc(((var(--sizeBtnWidth) * 1.414) - var(--sizeBtnWidth)) * -0.5));
	}

	.menu-btn-1.active span {
		background: transparent;
	}

	.menu-btn-1.active span::before {
		margin-top: 0;

		width: calc(var(--sizeBtnWidth) * 1.414);
		background-color: var(--hoverPrimaryColor);

		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.menu-btn-1.active span::after {
		margin-top: 0;

		width: calc(var(--sizeBtnWidth) * 1.414);
		background-color: var(--hoverPrimaryColor);

		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default BurgerMenuIconStyle;
